export default __webpack_public_path__ + "static/media/logo-dark.8517b867.svg";